// export const initLazyLoading = () => {
//
//     let lazyImages = document.querySelectorAll(".lazy-loaded-image.lazy");
//
//     let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
//         entries.forEach(function(entry) {
//             if (entry.isIntersecting) {
//                 let lazyImage = entry.target;
//                 lazyImage.src = lazyImage.dataset.src;
//                 lazyImage.classList.remove("lazy");
//                 lazyImageObserver.unobserve(lazyImage);
//             }
//         });
//     });
//
//     lazyImages.forEach(function(lazyImage) {
//         lazyImageObserver.observe(lazyImage);
//     });
// };

export const initInviewObserver = () => {

    const observedElements = document.querySelectorAll(".inview-observe")

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            let elm = entry.target;
            if (entry.isIntersecting) {
                elm.classList.add("is-inview");
            } else {
                elm.classList.remove("is-inview");
            }
        })
    }

    const options = {
        threshold: 0.1
    }

    const observer = new IntersectionObserver(callback, options)

    observedElements.forEach( element => {
        observer.observe(element)
    })
};

